<template>

    <div>
        <app-page-header></app-page-header>
        <v-container  grid-list-xl class="box">
            <v-form id="form_rfid_user" ref="form" v-model="valid" lazy-validation>
                <v-layout row wrap align-center justify-center fill-height>
                    <v-flex xs12 sm12 md10 lg10 xl8>
                        <v-card id="form_card">
                            <v-card-title>
                                <v-icon left>mdi-clipboard-account</v-icon>
                                    <span class="subtitle-1 font-weight-regular application--card--title">Podatki o članu</span>
                                    <v-spacer></v-spacer>
                                <v-btn icon @click="card1 = !card1">
                                    <v-icon>{{ card1 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-divider v-show="card1"></v-divider>
                            <!-- osebni podatki -->
                            <v-card-text v-show="card1">
                                <br>
                                <v-row class="">
                                    <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="col--dense--1">    
                                        <v-text-field
                                        v-model="firstname"
                                        label="Ime"
                                        required
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        readonly
                                        :filled="firstname !== null && firstname !== ''"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="col--dense--1"> 
                                        <v-text-field
                                        v-model="lastname"
                                        label="Priimek"
                                        required
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        readonly
                                        :filled="lastname !== null && lastname !== ''"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row class="">
                                    <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="col--dense--1">    
                                        <v-text-field
                                        v-model="address"
                                        label="Naslov"
                                        required
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        readonly
                                        :filled="address !== null && address !== ''"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="col--dense--1">
                                        <v-text-field
                                        v-model="house_number"
                                        label="Hišna številka"
                                        required
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        readonly
                                        :filled="house_number !== null && house_number !== ''"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4" class="col--dense--1">  
                                        <v-text-field
                                        v-model="house_number_addon"
                                        label="Dodatek k hišni številki"
                                        required
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        readonly
                                        :filled="house_number_addon !== null && house_number_addon !== ''"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <!--<v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">-->
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="col--dense--1">
                                        <v-text-field
                                        v-model="town"
                                        label="Kraj"
                                        required
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        readonly
                                        :filled="town !== null && town !== ''"
                                        ></v-text-field>
                                    </v-col>

                                    <!--<v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">-->
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="col--dense--1">
                                        <v-select
                                            v-model="postcode_id"
                                            :items="postcodes"
                                            label="Izberi pošto in poštno številko"
                                            item-value="id"
                                            item-text="code_and_name"
                                            no-data-text="Ni podatkov za prikaz"
                                            class="pt-1"
                                            readonly
                                            :filled="postcode_id !== null && postcode_id !== ''"
                                        ></v-select> 
                                    </v-col>
                                </v-row>
                                <v-row class="">
                                    <!--<v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">    -->
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="col--dense--1">
                                        <v-text-field
                                        v-model="phone_number"
                                        label="Telefonska številka"
                                        required
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        readonly
                                        :filled="phone_number !== null && phone_number !== ''"
                                        ></v-text-field>
                                    </v-col>
                                    <!--<v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">-->
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="col--dense--1">
                                        <v-text-field
                                        v-model="email"
                                        label="E-pošta"
                                        required
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        readonly
                                        :filled="email !== null && email !== ''"
                                        ></v-text-field>
                                    </v-col>
                                    <!--<v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">  -->
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="col--dense--1">
                                        <v-text-field
                                        v-model="tax_number"
                                        label="Davčna številka"
                                        required
                                        :rules="[]"
                                        append-icon="mdi-pencil"
                                        readonly
                                        :filled="tax_number !== null && tax_number !== ''"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card-text>

                            <!-- podatki o članarini -->
                            <v-divider></v-divider>
                            <v-app-bar
                                flat
                                color="grey lighten-4"
                                dense
                                class="elevation-0"
                            >   
                                <v-icon left>mdi-file-document-outline</v-icon>
                                <v-toolbar-title class="body-2">Podatki o članarini</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="card2 = !card2">
                                    <v-icon>{{ card2 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>

                            </v-app-bar>
                            <v-divider></v-divider>
                            <v-card-text v-show="card2">
                                
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <!-- aktivacija članarine -->
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Aktiviraj članarino</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-switch
                                                v-model="membership_active"
                                                :label="`Aktivni član: ${membershipActiveLabel}`"
                                                color="secondary"
                                                hide-details
                                                readonly
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>

                                    <!-- datum rojstva -->
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi datum rojstva</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-menu
                                                ref="date_of_birth_menu"
                                                :close-on-content-click="false"
                                                v-model="date_of_birth_menu"
                                                :nudge-right="40"
                                                :return-value.sync="date_of_birth"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="date_of_birth_formatted"
                                                        label="Datum rojstva"
                                                        append-icon="mdi-calendar-today"
                                                        readonly
                                                        :filled="date_of_birth_formatted !== null && date_of_birth_formatted !== ''"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="dateMenuSave('date_of_birth')" v-model="date_of_birth" no-title scrollable locale="sl-si">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- vrsta članarine -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi članarino</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                                :items="membershipFees"
                                                label="Izberi članarino"
                                                v-model="membership_fee"
                                                persistent-hint
                                                clearable
                                                item-text="name"
                                                item-value="id"
                                                no-data-text="Ni podatkov za prikaz"
                                                readonly
                                                filled
                                                return-object
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- vrsta člana
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi vrsto člana</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                                :items="memberClassifications"
                                                label="Vrsta člana"
                                                item-text="name"
                                                item-value="id"
                                                v-model="member_classification_id"
                                                persistent-hint
                                                readonly
                                                :filled="member_classification_id !== null && member_classification_id !== ''"
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                -->

                                <!-- tip člana -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi tip člana</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                                :items="memberTypes"
                                                label="Tip člana"
                                                item-text="name"
                                                item-value="id"
                                                v-model="member_type_id"
                                                persistent-hint
                                                readonly
                                                :filled="member_type_id !== null && member_type_id !== ''"
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>


                                <!-- datum pridružitve -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi datum pridružitve</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-menu
                                                ref="date_of_registration_menu"
                                                :close-on-content-click="false"
                                                v-model="date_of_registration_menu"
                                                :nudge-right="40"
                                                :return-value.sync="date_of_registration"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="date_of_registration_formatted"
                                                        label="Datum pridružitve"
                                                        append-icon="mdi-calendar-today"
                                                        readonly
                                                        :filled="date_of_registration_formatted !== null && date_of_registration_formatted !== ''"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="dateMenuSave('date_of_registration')" v-model="date_of_registration" no-title scrollable locale="sl-si">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- datum izstopa -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi datum izstopa</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-menu
                                                ref="date_of_withdrawal_menu"
                                                :close-on-content-click="false"
                                                v-model="date_of_withdrawal_menu"
                                                :nudge-right="40"
                                                :return-value.sync="date_of_withdrawal"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="date_of_withdrawal_formatted"
                                                        label="Datum izstopa"
                                                        append-icon="mdi-calendar-today"
                                                        readonly
                                                        :filled="date_of_withdrawal_formatted !== null && date_of_withdrawal_formatted !== ''"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="dateMenuSave('date_of_withdrawal')" v-model="date_of_withdrawal" no-title scrollable locale="sl-si">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- datum smrti -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi datum smrti</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-menu
                                                ref="date_of_death_menu"
                                                :close-on-content-click="false"
                                                v-model="date_of_death_menu"
                                                :nudge-right="40"
                                                :return-value.sync="date_of_death"
                                                
                                                transition="scale-transition"
                                                offset-y
                                                
                                                min-width="290px"
                                                >
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                    v-on="on"
                                                        v-model="date_of_death_formatted"
                                                        label="Datum smrti"
                                                        append-icon="mdi-calendar-today"
                                                        readonly
                                                        :filled="date_of_death_formatted !== null && date_of_death_formatted !== ''"
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker color="secondary" @input="dateMenuSave('date_of_death')" v-model="date_of_death" no-title scrollable locale="sl-si">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- vrsta izstopa -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Izberi vrsto izstopa</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-select
                                                :items="withdrawalTypes"
                                                label="Vrsta izstopa"
                                                item-text="name"
                                                item-value="id"
                                                v-model="withdrawal_type_id"
                                                persistent-hint
                                                readonly
                                                :filled="withdrawal_type_id !== null && withdrawal_type_id !== ''"  
                                            ></v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                                <!-- opomba -->
                                <v-container grid-list-xl text-x-center align-center class="container--dense-1">
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-7 pl-0"><strong>Opombe</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center>
                                            <v-textarea
                                            outlined
                                            name="input-7-4"
                                            label="Opombe"
                                            v-model="note"
                                            counter
                                            required
                                            class="mt-6"
                                            readonly
                                            :filled="note !== null && note !== ''"
                                            ></v-textarea>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>

                            <!-- podatki o kartici -->
                            <v-divider></v-divider>
                            <v-app-bar
                                flat
                                color="grey lighten-4"
                                dense
                                class="elevation-0"
                            >   
                                <v-icon left>mdi-credit-card-wireless-outline</v-icon>
                                <v-toolbar-title class="body-2">Podatki o kartici</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn icon @click="card3 = !card3">
                                    <v-icon>{{ card3 ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                                </v-btn>

                            </v-app-bar>
                            <v-divider></v-divider>
                            <v-card-text v-show="card3">
                                <div style="min-height:10px"></div>
                                <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-1"><strong>ID kartice</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center class="container--dense-1">
                                            <v-text-field
                                                v-model="card_id"
                                                label="ID kartice"
                                                required
                                                readonly
                                                :filled="card_id !== null && card_id !== ''"
                                                ref="cardId"
                                                :rules="getCardNumber ? card_id_rules : []"
                                                append-icon="mdi-tag-text-outline"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center>
                                            <v-subheader class="pt-1"><strong>Serijska številka kartice</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center class="container--dense-1">
                                            <v-text-field
                                                v-model="card_number"
                                                label="Serijska št. kartice"
                                                required
                                                readonly
                                                :filled="card_number !== null && card_number !== ''"
                                                ref="cardNumber"
                                                @keyup.enter.native="RfidNr"
                                                append-icon="mdi-numeric"
                                            ></v-text-field>
                                        </v-flex>
                                    </v-layout>

                                    <v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-center class="container--dense-1">
                                            <v-subheader class="pt-5"><strong>Kartica blokirana</strong></v-subheader>
                                        </v-flex>
                                        <v-flex xs12 md8 align-content-center class="container--dense-1">
                                            <v-switch
                                                v-model="card_blocked"
                                                :label="`Blokiraj kartico: ${cardBlocked}`"
                                                color="secondary"
                                                value="1"
                                                hide-details
                                                readonly
                                            ></v-switch>
                                        </v-flex>
                                    </v-layout>

                                    <div style="min-height:10px"></div>
                                    <!--<v-layout row justify-center v-bind="columnBinding">
                                        <v-flex xs12 md4 align-content-left v-if="$vuetify.breakpoint.lgAndUp">
                                            <v-subheader><strong></strong></v-subheader>
                                        </v-flex>
                                    </v-layout>-->
                            </v-card-text>

                            <v-divider></v-divider>
                            <v-card-text v-if="$vuetify.breakpoint.xsOnly">
                                <v-btn @click="goToRoute('members_list')" color="error" block outlined style="margin-bottom:10px;"><v-icon left>mdi-arrow-left</v-icon>Nazaj</v-btn>
                            </v-card-text>
                            <v-card-text v-else>
                                <v-btn @click="goToRoute('members_list')" color="error" text><v-icon left>mdi-arrow-left</v-icon>Nazaj</v-btn>
                            </v-card-text>

                        </v-card>
                    </v-flex>
                </v-layout>

                <div style="min-height:12px;"></div>
                <v-layout row wrap align-center justify-center fill-height>
                    <v-flex xs12 sm12 md10 lg10 xl8>
                        <invoices-data-table
                        :settings="dataTableSettings"
                        :queryParameters="queryParameters"
                        ></invoices-data-table> 
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>

        <data-table-toggle-columns
        :dataTableId="dataTableSettings.id"
        :columns="dataTableSettings.headers"
        :dataTableColumnsMenuId="dataTableSettings.eventBus.toggleColumnsId"

        ></data-table-toggle-columns>
    </div>

</template>


<script>
import { formatDate, randomPinNumber } from '@/helpers/utilities.js'
const InvoicesDataTable = () => import('@/components/InvoicesDataTable.vue')
const DataTableToggleColumns = () => import('@/components/DataTableToggleColumns.vue')

export default {

    components: {
        InvoicesDataTable,
        DataTableToggleColumns
    },

    data: () => ({
        valid: true,
        form: true,
        card1: true,
        card2: true,
        card3: true,
        card4: true,
        card5: true,
        card6: true,
        card7: true,
        card8: true,

        loading: false,
        storeItemLoading: false,
        scanRfidLoading: false,
        paymentLoading: false,
        membership_fee: null,

        member_uuid: null,
        firstname: null,
        lastname: null,
        address: null,
        house_number: null,
        house_number_addon: null,
        postcode_id: null,
        town: null,
        gender_id: null,
        phone_number: null,
        email: null,
        tax_number: null,
        membership_active: false,
        date_of_birth: null,
        member_type_id: null,
        member_classification_id: null,
        date_of_registration: null,
        date_of_withdrawal: null,
        date_of_death: null,
        withdrawal_type_id: null,
        note: null,
        card_id: null,
        card_number: null,
        card_scan_input: null,
        card_blocked: false,
        membership_fee_payment_year: null,

        date_of_birth_menu: false,
        date_of_registration_menu: false,
        date_of_withdrawal_menu:false,
        date_of_death_menu: false,

        date_of_birth_formatted: null,
        date_of_registration_formatted: null,
        date_of_withdrawal_formatted: null,
        date_of_death_formatted: null,

        card_number_input_enabled: false,
        card_id_input_enabled: false,


        postcodes: [],
        gender: [],
        memberTypes: [],
        memberClassifications: [],
        withdrawalTypes: [],
        years: [],
        membershipFees: [],

        //rules
        firstname_rules: [v => !!v || 'Polje ime je obvezno'],
        lastname_rules: [v => !!v || 'Polje priimek je obvezno'],
        card_id_rules: [
            v => (!!v) || 'Vnos ID kartice je obvezen!',
        ],

        dataTableSettings: {
            id: 'dtEvents',
            title: 'Seznam plačanih članarin',
            sortColumn: ['id'],
            sortDirection: ['desc'],
            progressHeight: 4,
            headers: [
                { text: "ID", value: "id", class: "text-xs-left", visibility: true},
                { text: "Plačnik", value: "payer", class: "text-xs-left", visibility: true},
                { text: "Član", value: "member", class: "text-xs-left", visibility: true},
                { text: "Tip člana", value: "member.member_type", class: "text-xs-left", visibility: true},
                //{ text: "Vrsta člana", value: "member.member_classification", class: "text-xs-left", visibility: true},
                { text: "Članarina", value: "membership_fee", class: "text-xs-left", visibility: true},
                { text: "Leto", value: "membership_fee_year", class: "text-xs-left", visibility: true},
                { text: "Znesek", value: "amount", class: "text-xs-left", visibility: true},
                {text: "Datum plačila", value: "created_at_formatted", class: "text-xs-left", visibility: true},
                { text: "Upravljanje", value: "action", align: "right", class: "text-xs-right", sortable: false, visibility: true, permissions:[]},
            ],
            updateInterval: true,
            rowsPerPage: 10,
            endpoint: '',
            editItem: {
                route: null,
                routeParameterValue: null
            },
            viewItem: {
                route: null,
                routeParameterValue: null
            },
            deleteItem: {
                vuexAction: 'DELETE_INVOICE',
                replaceStrWithColumnValue: 'id',
                confirmationText : "Sta prepričani da želite odstraniti članarino št. {str_to_replace} ?",
                dialogConfirmSuccessText: 'Članarina številka {str_to_replace} je bila uspešno odstranjena.',
                dialogConfirmFailText: 'Pri odstranjevanju članarine {str_to_replace} je prišlo do napake. Poskusite ponovno.'
            },

            toolbar: {
                buttons: {
                    refresh: true,
                    export: false,
                    addNew: true,
                    addNewRoute: 'add_member',
                    toggleColumns: true
                }
            },

            eventBus: {
                refreshDataTable: 'refresh_dt_invoices',
                totalItems : {
                    event: ''
                },
                search: 'dt-rfid-invoices-search',
                toggleColumnsId: 'toggle-rfid-invoices-list-columns'
            }


        }
    }),

    watch: {
        date_of_birth(val) {
            this.date_of_birth_formatted = formatDate(val)
        },

        date_of_registration(val) {
            this.date_of_registration_formatted = formatDate(val)
        },

        date_of_withdrawal(val) {
            this.date_of_withdrawal_formatted = formatDate(val)
        },

        date_of_death(val) {
            this.date_of_death_formatted = formatDate(val)
        }
    },

    computed: {
        columnBinding() {
            const binding = {}

            if (this.$vuetify.breakpoint.mdAndDown) binding.column = true

            return binding
        },

        queryParameters() {
            return {}
        },

        cardBlocked() {
            if(this.card_blocked) {
                return 'DA'
            }

            return 'NE'
        },

        getCardNumber() {
           if(this.card_number == null || this.card_number == '') return false

           return true
        },

        cardIdValue() {
            return this.card_id
        },

        membershipActiveLabel() {
            if(this.membership_active) {
                return 'DA'
            }

            return 'NE'
        }
    },

    methods: {
        getMemberData() {
            var vm =  this
            vm.$store.commit('SET_PROGRESS', true)
            vm.storeUserLoading = true
            vm.$store.commit('SET_LOADER_TEXT', 'Pridobivanje podatkov o članu...')
            vm.$store.commit('SET_LOADER', true)
            vm.$store.dispatch('GET_MEMBER', vm.member_uuid)
            .then(response => {
                //window.console.log(response.data)
                vm.firstname = response.data.firstname
                vm.lastname = response.data.lastname
                vm.address = response.data.address
                vm.house_number = response.data.house_number
                vm.house_number_addon = response.data.house_number_addon
                vm.town = response.data.town
                vm.postcode_id = response.data.postcode_id
                vm.phone_number = response.data.phone_number
                vm.email = response.data.email
                vm.tax_number = response.data.tax_number
                vm.membership_active = response.data.membership_active
                vm.date_of_birth = response.data.date_of_birth
                vm.member_classification_id = response.data.member_classification_id
                vm.member_type_id = response.data.member_type_id
                vm.date_of_registration = response.data.date_of_registration
                vm.date_of_withdrawal = response.data.date_of_withdrawal
                vm.date_of_death = response.data.date_of_death
                vm.withdrawal_type_id = response.data.withdrawal_type_id
                vm.note = response.data.note
                vm.card_id = response.data.card_id
                vm.card_number = response.data.card_number
                vm.card_scan_input = response.data.card_scan_input

                if(response.data.card_blocked == 1) {
                    vm.card_blocked = "1"
                } else {
                    vm.card_blocked = null
                }

                setTimeout(() => {
                    vm.membershipFees.forEach(item => {
                    if(item.id == response.data.membership_fee_id) {
                        vm.membership_fee = item
                    }
                })
                }, 1000)
               
            })
            .catch(error => {
                window.console.error('### ERROR ViewMember@getMemberData ###')
                window.console.error(error)
                vm.$store.commit('snackbarDisplay', false)
                vm.$store.commit('snackbarMode', 'multi-line')
                vm.$store.commit('snackbarText', 'Pri pridobivanju podatkov o članu je prišlo do napake.')
                vm.$store.commit('snackbarDisplay', true)
            })
            .finally(() => {
                setTimeout(() => {
                    //vm.$store.commit('SET_PROGRESS', false)
                    vm.$storeUserLoading = false
                    vm.$store.commit('SET_LOADER', false)
                    vm.$store.commit('SET_LOADER_TEXT', '')
                }, 600)
            })
        },

        goToRoute(routeName) {
            this.$router.push({
                name: routeName
            })
        },

        dateMenuSave(parameter) {
            if(parameter == 'date_of_birth') {
                this.$refs.date_of_birth_menu.save(this.date_of_birth)
                this.date_of_birth_menu = false
            }

            if(parameter == 'date_of_registration') {
                this.$refs.date_of_registration_menu.save(this.date_of_registration)
                this.date_of_registration_menu = false
            }

            if(parameter == 'date_of_withdrawal') {
                this.$refs.date_of_withdrawal_menu.save(this.date_of_withdrawal)
                this.date_of_withdrawal_menu = false
            }

            if(parameter == 'date_of_death') {
                this.$refs.date_of_death_menu.save(this.date_of_death)
                this.date_of_death_menu = false
            }
        },


    },

    created() {
        var vm = this
        this.$store.dispatch('ROUTE_NAME', this.$route.name) 
        this.member_uuid = this.$route.params.id
        vm.$store.commit('SET_PROGRESS', true)
        vm.$store.dispatch('PARAMETERS_DATA')
        .then(response => {
            //window.console.log(response.data)
            vm.gender = response.data.gender
            vm.postcodes = response.data.postcodes
            vm.memberTypes = response.data.memberTypes
            vm.memberClassifications = response.data.memberClassifications
            vm.withdrawalTypes = response.data.withdrawalTypes
            vm.years = response.data.years
            vm.membershipFees = response.data.membershipFees
        })
        .catch(error => {
            window.console.error("### ERROR Users.vue@mounted ###");
            window.console.error(error)
        })
        .finally(() => {
            vm.$store.commit('SET_PROGRESS', false)
        })
        if(this.member_uuid != null) {
            this.getMemberData()
        }
    },

    mounted() {
        var vm = this
        vm.dataTableSettings.endpoint = 'sobec/members/' + this.$route.params.id + "/payments"
    },

    beforeDestroy() {

    },

    destroyed() {

    }
}

</script>

<style scope>
    .btn_rfid {
        margin-right:10px;
        margin-bottom: 15px;
    }

    .v-card__text {
        color: rgba(0,0,0,0.90) !important;
    }
</style>


